export function isStringNullOrEmpty(value: string): boolean {
  if (!value || (value.length && value.length === 0)) {
    return true;
  }
  return false;
}
